import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { ThemeService } from 'src/@core/services/theme.service';

@Component({
  selector: 'hour4u-admin-create-leads-user-new',
  templateUrl: './create-leads-user-new.component.html',
  styleUrls: ['./create-leads-user-new.component.scss']
})
export class CreateLeadsUserNewComponent implements OnInit {

  leadsUserCreateForm: FormGroup;
  submitted = false;
  profile = this.appService.getCurrentAccount();
  isUpdate: boolean = false;
  // sendLinkList = [
  //   { name: 'WhatsApp', selected: false },
  //   // { name: 'Text', selected: false },
  //   // { name: 'Email', selected: false },
  // ];
  checkIcon = 'icon-check';
  plusIcon = 'icon-plus';

  constructor(
    public dialogRef: MatDialogRef<CreateLeadsUserNewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private notify: NotificationService,
    private appService: AppService,
    private jobService: JobService,
    public themeService: ThemeService
  ) { }

  ngOnInit() {
    this.createForm();
    console.log(this.data)
  }

  createForm() {
    this.leadsUserCreateForm = this.fb.group({
      users: this.fb.array([this.createUserForm()])
    });
  }

  get users(): FormArray {
    return this.leadsUserCreateForm.get('users') as FormArray;
  }

  createUserForm(): FormGroup {
    return this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      mobile: [
        '',
        [
          Validators.required,
          Validators.pattern('^[5-9][0-9]{9}$'),
          Validators.minLength(10),
          Validators.maxLength(10)
        ]
      ],
      email: ['', [Validators.required, Validators.email]],
      country_code: ["91"]
    });
  }

  addUser(): void {
    this.users.push(this.createUserForm());
  }

  removeUser(index: number): void {
    this.users.removeAt(index);
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave(): void {
    this.submitted = true;
    if (this.leadsUserCreateForm.invalid) {
      this.leadsUserCreateForm.markAllAsTouched();
      this.submitted = false;
      return;
    } else {
      let obj = {
        "caller_details": this.leadsUserCreateForm.value.users
      }
      this.jobService.createLeadUser(obj, this.profile.entity.id, this.data.project_id).subscribe(res => {
        this.submitted = false;
        this.notify.showMessage("Created Leads User successfully!", 3000);
        this.dialogRef.close(true);
      }, (err => {
        this.submitted = false;
      }))
    }
  }

  // ✅ Create a getter to access the FormArray in HTML
  get usersArray(): FormArray {
    return this.leadsUserCreateForm.get('users') as FormArray;
  }
}
